var map = {
	"./en-gb": "./node_modules/.pnpm/moment@2.30.1/node_modules/moment/locale/en-gb.js",
	"./fi": "./node_modules/.pnpm/moment@2.30.1/node_modules/moment/locale/fi.js",
	"./nb": "./node_modules/.pnpm/moment@2.30.1/node_modules/moment/locale/nb.js",
	"./sv": "./node_modules/.pnpm/moment@2.30.1/node_modules/moment/locale/sv.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/.pnpm/moment@2.30.1/node_modules/moment/locale sync recursive (sv%7Cen-gb%7Cfi%7Cnb)$";